module.exports = __webpack_public_path__ + "static/media/TPCSILVER.a734e3d5.jpg";